import colors from "core/colors";

// Brand Colors
// per Figma: https://www.figma.com/file/xTLiaJuirKEJSb5czcp6lK/NounDesignSystem?node-id=12830%3A58156&mode=dev
// Creating Primary And Secondary variations even though design has not yet defined each variation types (default, removeable)
// As a result, many of these colors repeat themselves at the moment - future proofing for when these are defined by design
export let brand = {
    primary: {
        default: {
            static: {
                color: colors.accent.lightMode.persian,
                background: colors.primary.diamond
            },
            hover: {
                color: colors.secondary.cosmic,
                background: colors.primary.moon
            },
            disabled: {
                color: colors.secondary.oolong,
                background: colors.accent.darkMode.suenosBuenos
            }
        },
        removeable: {
            static: {
                color: colors.accent.lightMode.persian,
                background: colors.primary.diamond
            },
            hover: {
                color: colors.secondary.cosmic,
                background: colors.primary.moon
            },
            disabled: {
                color: colors.secondary.oolong,
                background: colors.accent.darkMode.suenosBuenos
            }
        }
    }
};

// only those things that are different
brand.secondary = {
    default: brand.primary.default,
    removeable: {
        static: {
            color: colors.secondary.basalt,
            background: colors.primary.diamond
        },
        hover: {
            color: colors.secondary.cosmic,
            background: colors.primary.moon
        },
        disabled: {
            color: colors.secondary.basalt,
            background: colors.primary.diamond
        }
    }
};

export const getBrandObject = ({ brandType, type }) => {
    return brand[brandType][type];
};
